module.exports = __webpack_public_path__ + "img/4-4.294625af.png";